const config = {
  siteTitle: 'Aman Mittal',
  siteUrl: 'https://amanhimself.dev',
  description: 'Software engineer and technical content writer.',
  username: 'Alec Campbell',
  shortname: '@fu4303',
  newsletter: 'https://amanhimself.substack.com/',
  github: 'https://github.com/fu4303',
  twitter: 'https://twitter.com/fu4303',
  medium: 'https://medium.com/@amanhimself',
  devto: 'https://dev.to/fu4303',
  hashnode: 'https://hashnode.com/@fu4303',
  instagram: 'https://www.instagram.com/amanhimselfcodes/',
  hundredDaysOfCodeBot: 'https://twitter.com/_100Daysofcode',
  mailAddress: 'mailto:amanmittal.work@gmail.com',
  kofi: 'https://ko-fi.com/amanhimself',
  twitterBotRepo: 'https://github.com/freeCodeCamp/100DaysOfCode-twitter-bot',
  goodreads: 'https://www.goodreads.com/author/show/17657541.Aman_Mittal',
  subscribersCount: '1200+'
};

export const SavedTweets = {
  twoMillionViews: 'https://twitter.com/amanhimself/status/1285554115464982528',
  topContributorFreeCodeCamp2018:
    'https://www.freecodecamp.org/news/announcing-our-freecodecamp-2018-top-contributor-award-winners-861da08a77e1/'
};

export default config;
